export default {
  store: {
    list: {
      title: '已注册店铺',
       tableHeader: {
        index: "序号",
        storeName: "店铺名",
        receiptName: "收据名",
        category: "分类",
        industryDetail: "行业详情",
        address: "地址",
        status: "状态"

      },
      deleteConfirm: "确定要删除店铺「{name}」吗？",
      empty: "尚未登记店铺信息"
    },
     
  
      notice: {
        icon: "!",
        title: "店铺信息登记注意事项",
        item1: "请填写所有使用支付服务的店铺信息。",
        item2: "「店铺名」需在32个全角字符以内，不可使用符号。",
        item3: {
          title: "若无店铺信息URL，请提交以下资料：",
          sub1: "店铺外观（需包含店铺名称）",
          sub2: "可确认商品/材料的资料（陈列场所、菜单表等）"
        },
        item4: "若无法准备以上资料，请在「文件上传」页面查看详细说明。"
      },

      banknotice: {
      title: '结算支付入金用银行账户信息',
      tips: '希望变更入金账户的加盟店，申请中可能无法更改。',
      noticeItems: [
        '状态若非"申请成功"或发生错误，请务必联系我们',
        '变更入金账户时，可能会另行联系确认',
        '请仔细确认账户信息，避免输入错误',
        '结算金额未满30万日元时，每个账户扣除220日元（含税）手续费'
      ],
    },
    
    login: {
      title: '店铺注册（＊必填项）',
      label1: '店铺名称',
      tip1: '例：环球支付',
      label2: '全角片假名',
      tip2: '例：カンキュウシフ',
      label3: '英文',
      tip3: '例：GLOBEPAY',
      label4: '行业（类别）',
      tip4: '选择',
      label5: '行业（详细）',
      tip5: '选择',
      label6: '商材详细',
      tip6: '例：饮食店经营',
      label7: 'url',
      tip7: '例：https://www.globepay.co.jp',
      label8: '店铺外部、内部的照片',
      tip8: '文件格式：JPEG、PNG、JPG。文件尺寸限制：10MB内',
      label9: '销售商品最小单价/日元',
      tip9: '0',
      label10: '销售商品最大单价/日元',
      tip10: '0',
      label11: '银行账号',
      tip11: '例：1832',
      label12: '是否可以在地图上公开信息',
      tip12: '',
      label13: '营业时间',
      tip13: '',
      label14: '休息日',
      tip14: '',
       label15: '店铺营业开始日',
      tip15: '',
    },
    home: {
      title: '店铺地址信息',
      label1: '邮政编码',
      tip1: '例：1030026',
      label2: '建筑物名称及房间号码等',
      tip2: '例：1-1008',
      label3: '电话号码',
      tip3: '例：03-6284-2302',
      label4: '电子邮件地址',
      tip4: '例：xxx@gmail.com（※邮箱非常重要。用于联络申请内容和发送支付系统的ID/PW。）',
      label5: '营业执照及其他证件等的编号',
      tip5: '例：03-6284-2302',
    },
    bank: {
      title: '结算用银行账户信息',
      label1: '金融机构代码',
      tip1: '例：0001',
      label2: '金融机构名称',
      tip2: '例：瑞穗银行',
      label3: '分行代码',
      tip3: '例：001',
      label4: '分行名称',
      tip4: '例：东京营业部',
      label5: '账户号码',
      tip5: '例：1234567 （※如果您是邮政银行的帐号并且是8位数字，请删除最后1位数字并输入）',
      label6: '账户类型',
      tip6: '例：活期存款',
      label7: '账户持有人姓名',
      tip7: '例：环球支付',
      label8: '半角片假名',
      tip8: '例：ｶﾝｷｭｳｼﾌ',
    },
    copyaddressbtn:'本社住所から複製',
    deleteConfirm: '确定删除该店铺',
    cancel: '取消',
    ok:'确定',
    submit: '提交',
    phone: '电话:'
  }
}
